import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Spinner,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { loadMercadoPago } from "@mercadopago/sdk-js";
import classnames from "classnames";
import { URL_PreScheduling } from "../Services/preSchedulingService";
import axios from "axios";
import { CustomModal } from "../../common/components/utils/customModal";
import { FaCheck } from "react-icons/fa";
import "./index.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const MercadoPagoCheckout = () => {
  const [mp, setMp] = useState(null);
  const [cardForm, setCardForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pixLoading, setPixLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [pixModal, setPixModal] = useState(false);
  const [pixPaymentData, setPixPaymentData] = useState(null);
  const [schedulingData, setSchedulingData] = useState(null);
  const [clinicData, setClinicData] = useState(null);
  const [providerData, setProviderData] = useState(null);
  const [validationErrors, setValidationErrors] = useState([]);
  const [paymentData, setPaymentData] = useState({
    amount: 0,
    description: "Descrição do produto",
  });
  const myParam = window.location.pathname.split("/")[1];
  const [pixFormData, setPixFormData] = useState({
    payerFirstName: "",
    payerLastName: "",
    email: "",
    identificationNumber: "",
  });
  const [scheduling, setScheduling] = useState(false);
  const [shouldReinitialize, setShouldReinitialize] = useState(false);
  const navigate = useNavigate();
  // Device ID do Mercado Pago (gerado automaticamente pelo SDK JS na variável
  // global window.MP_DEVICE_SESSION_ID). Enviado ao backend para melhorar a
  // aprovação e reduzir rejeições indevidas por risco em pagamentos legítimos.
  const getDeviceId = () =>
    window.MP_DEVICE_SESSION_ID ||
    document.getElementById("deviceId")?.value ||
    null;
  // Arredonda o valor para 2 casas decimais. Necessário porque a soma dos
  // valores dos serviços pode gerar imprecisão de ponto flutuante (ex.:
  // 0.6000000000000001), o que faz a API do Mercado Pago rejeitar com o erro
  // "Invalid transaction_amount".
  const roundAmount = (value) => Math.round(Number(value || 0) * 100) / 100;
  // Estilo aplicado aos campos em iframe do Mercado Pago (cartão, validade e
  // CVC) para que o tamanho do texto fique harmonizado com os inputs nativos.
  const mpFieldStyle = {
    fontSize: "14px",
    color: "#111827",
    placeholderColor: "#9ca3af",
  };
  // Carrega o script de segurança do Mercado Pago para coletar o Device ID.
  // Cria a variável global window.MP_DEVICE_SESSION_ID e também popula o input
  // oculto #deviceId (fallback). Isso melhora a aprovação dos pagamentos.
  useEffect(() => {
    if (document.getElementById("mp-security-script")) return;
    const script = document.createElement("script");
    script.id = "mp-security-script";
    script.src = "https://www.mercadopago.com/v2/security.js";
    script.setAttribute("view", "checkout");
    script.setAttribute("output", "deviceId");
    document.body.appendChild(script);
  }, []);
  // Função para validar email
  const validateEmail = (email) => {
    if (!email || email.trim() === "") {
      return { isValid: false, message: "E-mail é obrigatório." };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { isValid: false, message: "E-mail inválido." };
    }

    return { isValid: true };
  };
  // Inicializar Mercado Pago
  useEffect(() => {
    const initializeMercadoPago = async () => {
      try {
        await loadMercadoPago();
        const clinic = JSON.parse(localStorage.getItem("dataClinic"));
        let modelScheduling = JSON.parse(localStorage.getItem("mapscheduling"));

        setPaymentData({
          ...paymentData,
          amount: roundAmount(modelScheduling?.value),
          description: "Compra em " + clinic?.corporateName,
        });
        setPixFormData({
          payerFirstName: modelScheduling?.name,
          email: modelScheduling?.email,
        });
        // const mercadoPago = new window.MercadoPago(clinic.publicKeyMercadoPago);
        const mercadoPago = new window.MercadoPago(
          clinic.publicKeyMercadoPago,
          {
            locale: "pt-BR",
          },
        );

        setMp(mercadoPago);
        setSchedulingData(modelScheduling);
        setClinicData(clinic);
        setProviderData(JSON.parse(localStorage.getItem("providerSelected")));

        if (!clinic.enableCreditCard) {
          setActiveTab("2");
        }
        if (!clinic.enablePix) {
          setActiveTab("1");
        }
      } catch (err) {
        setError("Erro ao inicializar o Mercado Pago");
        console.error(err);
      }
    };

    initializeMercadoPago();
  }, []);

  // Inicializar o formulário de cartão quando o Mercado Pago estiver pronto
  // IMPORTANTE: só inicializa quando o valor já estiver carregado (> 0). Se o
  // cardForm for criado com amount = 0, o Mercado Pago não consegue calcular as
  // parcelas e o <select> de parcelas fica vazio, o que faz a API rejeitar o
  // pagamento com o erro "filter_installments".
  useEffect(() => {
    if (
      ((mp && activeTab === "1") || shouldReinitialize) &&
      Number(paymentData.amount) > 0
    ) {
      initializeCardForm();
      setShouldReinitialize(false);
    }
  }, [mp, activeTab, shouldReinitialize, paymentData.amount]);

  const initializeCardForm = () => {
    try {
      setValidationErrors([]);
      setError(null);
      // Limpar formulário anterior se existir
      if (cardForm) {
        cardForm.unmount();
      }

      const form = mp.cardForm({
        amount: paymentData.amount.toString(),
        iframe: true,
        form: {
          id: "form-checkout",
          cardNumber: {
            id: "form-checkout__cardNumber",
            placeholder: "Número do cartão",
            style: mpFieldStyle,
          },
          expirationDate: {
            id: "form-checkout__expirationDate",
            placeholder: "MM/AA",
            style: mpFieldStyle,
          },
          securityCode: {
            id: "form-checkout__securityCode",
            placeholder: "CVC",
            style: mpFieldStyle,
          },
          cardholderName: {
            id: "form-checkout__cardholderName",
            placeholder: "Nome como está no cartão",
          },
          issuer: {
            id: "form-checkout__issuer",
            placeholder: "Banco emissor",
          },
          installments: {
            id: "form-checkout__installments",
            placeholder: "Parcelas",
          },
          identificationNumber: {
            id: "form-checkout__identificationNumber",
            placeholder: "Número do documento",
          },
          cardholderEmail: {
            id: "form-checkout__cardholderEmail",
            placeholder: "E-mail",
          },
        },
        callbacks: {
          onFormMounted: (error) => {
            if (error) {
              console.warn("Form Mounted handling error: ", error);
              if (
                error.code === "v2:1" ||
                error.message?.includes("identification types")
              ) {
                console.log(
                  "Ignorando erro de identification types, continuando...",
                );
                return; // Ignora esse erro específico
              }
              setError("Erro ao carregar formulário de pagamento");
              return;
            }
            console.log("Formulário montado com sucesso");
          },
          onSubmit: async (event) => {
            event.preventDefault();
            // VALIDAÇÃO MANUAL DO CPF
            const cpfInput = document.getElementById(
              "form-checkout__identificationNumber",
            );
            const cpfValue = cpfInput?.value || "";

            const cpfValidation = validateCPF(cpfValue);
            if (!cpfValidation.isValid) {
              setValidationErrors([
                {
                  field: "identificationNumber",
                  message: cpfValidation.message,
                },
              ]);
              highlightErrorField("identificationNumber");
              setLoading(false);
              return; // Impede o envio do formulário
            }
            // VALIDAÇÃO MANUAL DO EMAIL
            const emailInput = document.getElementById(
              "form-checkout__cardholderEmail",
            );
            const emailValue = emailInput?.value || "";

            const emailValidation = validateEmail(emailValue);
            if (!emailValidation.isValid) {
              setValidationErrors([
                {
                  field: "cardholderEmail",
                  message: emailValidation.message,
                },
              ]);
              highlightErrorField("cardholderEmail");
              setLoading(false);
              return; // Impede o envio do formulário
            }
            await processCardPayment(form);
          },
          onFetching: (resource) => {
            console.log("Fetching resource: ", resource);
          },
          // NOVO: Callback para capturar erros de validação
          onError: (error) => {
            console.error("MercadoPago Validation Error:", error);

            // Filtrar erro de identification types
            const filteredErrors = Array.isArray(error)
              ? error.filter(
                  (err) =>
                    !err.message?.includes("identification types") &&
                    !err.code?.includes("v2:1"),
                )
              : error;

            if (
              filteredErrors &&
              Array.isArray(filteredErrors) &&
              filteredErrors.length > 0
            ) {
              const translatedErrors = filteredErrors.map((err) =>
                translateError(err),
              );
              setValidationErrors(translatedErrors);

              translatedErrors.forEach((err) => {
                if (err.field && err.field !== "general") {
                  highlightErrorField(err.field);
                }
              });
            } else if (filteredErrors && !Array.isArray(filteredErrors)) {
              setValidationErrors([
                {
                  field: "general",
                  message:
                    "Erro ao validar dados do cartão. Verifique as informações.",
                },
              ]);
            }

            setLoading(false);
          },
        },
      });

      setCardForm(form);
    } catch (err) {
      setError("Erro ao inicializar formulário de pagamento");
      console.error(err);
    }
  };

  const processCardPayment = async (form) => {
    setLoading(true);
    setError(null);
    setValidationErrors([]);
    try {
      const {
        paymentMethodId,
        issuerId: issuer_id,
        cardholderEmail: email,
        amount,
        token,
        installments,
        identificationNumber,
      } = form.getCardFormData();
      // Validação adicional do email antes do processamento
      const emailValidation = validateEmail(email);
      if (!emailValidation.isValid) {
        setValidationErrors([
          {
            field: "cardholderEmail",
            message: emailValidation.message,
          },
        ]);
        highlightErrorField("cardholderEmail");
        setLoading(false);
        return;
      }
      // VALIDAÇÃO DAS PARCELAS
      // Quando o seletor de parcelas ainda não foi preenchido pelo SDK do
      // Mercado Pago (ainda exibindo "Carregando..."), getCardFormData() retorna
      // um valor inválido. Number(...) vira NaN, que ao ser serializado/enviado
      // chega ao back-end como 0 (campo int não-nulo), e a API do Mercado Pago
      // rejeita o pagamento com o erro "filter_installments". Bloqueamos o envio
      // com uma mensagem clara em vez de mandar parcelas inválidas.
      const parsedInstallments = parseInt(installments, 10);
      if (!Number.isInteger(parsedInstallments) || parsedInstallments < 1) {
        setValidationErrors([
          {
            field: "installments",
            message:
              "Selecione o número de parcelas. Se a lista ainda estiver carregando, aguarde alguns segundos e tente novamente.",
          },
        ]);
        highlightErrorField("installments");
        setLoading(false);
        return;
      }
      const response = await axios.post(
        `${URL_PreScheduling}/process-card`,
        {
          token,
          IssuerId: issuer_id,
          paymentMethodId: paymentMethodId,
          transactionAmount: roundAmount(amount),
          installments: parsedInstallments,
          description: paymentData.description,
          deviceId: getDeviceId(),
          payer: {
            email,
            identification: {
              type: "CPF",
              number: identificationNumber,
            },
          },
        },
        {
          params: { alias: myParam },
        },
      );

      if (response.status === 200 || response.status === 201) {
        const result = response.data;
        if (result.status === "approved" || result.status === "pending") {
          setSuccess(true);
          await SaveSchedulindAndFinancial(false);
        } else {
          setError(
            `Pagamento não aprovado: ${getStatusDetailDescription(
              result.status_detail,
            )}`,
          );
        }
      } else {
        setError("Erro ao processar pagamento");
      }
    } catch (err) {
      console.error("🚨 ERRO COMPLETO NO processCardPayment:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          data: err.config?.data,
        },
        stack: err.stack,
      });
      setError("Erro ao processar pagamento. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const getStatusDetailDescription = (statusDetail) => {
    const statusDetailMessages = {
      // Status de pagamentos aprovados
      accredited: "Pagamento acreditado",
      partially_refunded: "Pagamento parcialmente reembolsado",

      // Status pendentes
      pending_contingency:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_manual:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_micro_debt:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_risk:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_data:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_manual_documentation:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_by_risk:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_by_compliance:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_final_customer:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_review_legal:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_card_validation:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_chargeback:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_waiting_payment: "Aguardando pagamento",
      pending_waiting_transfer: "Aguardando transferência",
      pending_by_risk:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_by_regulation:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_by_admin:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_capture: "Pagamento autorizado aguardando captura",
      pending_provider_validation:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_bank_review:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_medium_risk:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_high_risk:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_fraud_review:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_antifraud_review:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_require_kyc:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_require_client_action:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",
      pending_require_payment_method:
        "O pagamento está sendo processado. Em até 2 dias úteis informaremos por e-mail o resultado.",

      // Status rejeitados
      cc_rejected_bad_filled_card_number: "Número do cartão incorreto.",
      cc_rejected_bad_filled_date: "Data de expiração incorreta.",
      cc_rejected_bad_filled_other: "Outros dados do cartão incorretos.",
      cc_rejected_bad_filled_security_code: "Código de segurança incorreto.",
      cc_rejected_blacklist: "Não foi possível processar o pagamento.",
      cc_rejected_call_for_authorize:
        "O pagamento não foi autorizado. Entre em contato com o emissor do cartão.",
      cc_rejected_card_disabled:
        "Cartão inativo. Entre em contato com o emissor do cartão.",
      cc_rejected_card_error: "Não foi possível processar o pagamento.",
      cc_rejected_duplicated_payment: "Já existe um pagamento com estes dados.",
      cc_rejected_high_risk: "O pagamento foi recusado.",
      cc_rejected_insufficient_amount: "Saldo insuficiente.",
      cc_rejected_invalid_installments:
        "Parcelas não permitidas para este cartão.",
      cc_rejected_max_attempts: "Limite de tentativas excedido.",
      cc_rejected_other_reason: "Não foi possível processar o pagamento.",

      // Status de cartão
      cc_rejected_card_type_not_allowed: "Este tipo de cartão não é aceito.",
      cc_rejected_connection_failed: "Não foi possível processar o pagamento.",
      cc_rejected_contract_not_found: "Não foi possível processar o pagamento.",
      cc_rejected_currency_not_supported: "Moeda não suportada.",
      cc_rejected_debit_not_supported: "Cartão de débito não suportado.",
      cc_rejected_expired_card: "Cartão expirado.",
      cc_rejected_fraud: "Pagamento recusado por suspeita de fraude.",
      cc_rejected_global: "Pagamento recusado.",
      cc_rejected_invalid_account: "Conta inválida.",
      cc_rejected_invalid_amount: "Valor inválido.",
      cc_rejected_invalid_card: "Cartão inválido.",
      cc_rejected_invalid_operation: "Operação inválida.",
      cc_rejected_issuer_not_available: "Emissor do cartão indisponível.",
      cc_rejected_not_allowed: "Operação não permitida.",
      cc_rejected_not_authorized: "Pagamento não autorizado.",
      cc_rejected_payment_processor_not_available:
        "Processador de pagamento indisponível.",

      // Outros status
      expired: "Pagamento expirado.",
      refunded: "Pagamento reembolsado.",
      charged_back: "Pagamento contestado.",
      cancelled: "Pagamento cancelado.",
      rejected: "Pagamento rejeitado.",
      by_antifraud: "Pagamento recusado pelo sistema de antifraude.",
      by_admin: "Pagamento cancelado pelo administrador.",
      by_risk: "Pagamento recusado por políticas de risco.",
      by_compliance: "Pagamento recusado por políticas de compliance.",
      by_legal: "Pagamento recusado por questões legais.",
      by_regulation: "Pagamento recusado por regulamentação.",

      // Default
      default: "Status desconhecido. Entre em contato com o suporte.",
    };

    return (
      statusDetailMessages[statusDetail] || statusDetailMessages["default"]
    );
  };
  // Função para validar CPF manualmente
  const validateCPF = (cpf) => {
    if (!cpf || cpf.trim() === "") {
      return { isValid: false, message: "CPF é obrigatório." };
    }

    // Remove caracteres não numéricos
    const cleanCPF = cpf.replace(/\D/g, "");

    // Verifica se tem 11 dígitos
    if (cleanCPF.length !== 11) {
      return { isValid: false, message: "CPF deve ter 11 dígitos." };
    }

    // Verifica se não é uma sequência repetida
    if (/^(\d)\1+$/.test(cleanCPF)) {
      return { isValid: false, message: "CPF inválido." };
    }

    // Validação básica dos dígitos verificadores (opcional)

    return { isValid: true };
  };

  const translateError = (error) => {
    const message = error.message;

    // Detecta o campo baseado na mensagem
    let field = "general";
    let translatedMessage = message;

    if (message.includes("cardNumber")) {
      field = "cardNumber";
      if (message.includes("should be a number")) {
        translatedMessage = "Número do cartão deve conter apenas números.";
      } else if (message.includes("is empty")) {
        translatedMessage = "Número do cartão é obrigatório.";
      } else if (message.includes("length between")) {
        translatedMessage = "Número do cartão deve ter entre 8 e 19 dígitos.";
      }
    } else if (message.includes("securityCode")) {
      field = "securityCode";
      if (message.includes("should be a number")) {
        translatedMessage = "Código de segurança deve conter apenas números.";
      } else if (message.includes("length '3' or '4'")) {
        translatedMessage = "Código de segurança deve ter 3 ou 4 dígitos.";
      } else if (message.includes("is empty")) {
        translatedMessage = "Código de segurança é obrigatório.";
      }
    } else if (
      message.includes("expirationMonth") ||
      message.includes("expirationYear")
    ) {
      field = "expirationDate";
      if (message.includes("expirationMonth should be a number")) {
        translatedMessage = "Mês de expiração deve ser um número.";
      } else if (message.includes("expirationMonth is empty")) {
        translatedMessage = "Mês de expiração é obrigatório.";
      } else if (message.includes("expirationYear should be of length")) {
        translatedMessage = "Ano de expiração deve ter 2 ou 4 dígitos.";
      } else if (message.includes("expirationYear should be a number")) {
        translatedMessage = "Ano de expiração deve ser um número.";
      } else if (message.includes("expirationYear is empty")) {
        translatedMessage = "Ano de expiração é obrigatório.";
      }
    } else if (message.includes("identificationNumber")) {
      field = "identificationNumber";
      if (message.includes("should be a number")) {
        translatedMessage = "CPF deve conter apenas números.";
      } else if (message.includes("is empty")) {
        translatedMessage = "CPF é obrigatório.";
      } else if (message.includes("length between")) {
        translatedMessage = "CPF deve ter 11 dígitos.";
      } else if (message.includes("is invalid")) {
        translatedMessage = "CPF inválido.";
      }
    } else if (message.includes("cardholderEmail")) {
      field = "cardholderEmail";
      if (message.includes("is empty")) {
        translatedMessage = "E-mail é obrigatório.";
      } else if (message.includes("is invalid")) {
        translatedMessage = "E-mail inválido.";
      }
    }

    return {
      field,
      message: translatedMessage,
    };
  };

  // Função para destacar campos com erro
  const highlightErrorField = (fieldName) => {
    console.log("🎨 Destacando campo com erro:", fieldName);

    const element = document.getElementById(`form-checkout__${fieldName}`);
    if (element) {
      element.classList.add("error");

      // Remove o destaque após 5 segundos
      setTimeout(() => {
        if (element) {
          element.classList.remove("error");
        }
      }, 5000);
    } else {
      console.warn(
        "Elemento não encontrado para highlight:",
        `form-checkout__${fieldName}`,
      );
    }
  };

  const SaveSchedulindAndFinancial = async (pix, paymentIdMP = null) => {
    // Implementar a lógica para salvar o agendamento e integrar com o financeiro

    const cpfInput = document.getElementById(
      "form-checkout__identificationNumber",
    );

    schedulingData.birthDate = moment(
      schedulingData.birthDate,
      "DD/MM/yyyy",
    ).toDate();
    schedulingData.method = pix ? "pix" : "card";
    schedulingData.document = cpfInput?.value || "";
    //usado para esconder o agendamento até chegar a confirmação do pagamento
    schedulingData.isDeleted = pix ? true : false;
    schedulingData.paymentIdMP = paymentIdMP;

    await axios
      .post(
        `${URL_PreScheduling}/SaveSchedulindAndFinancial/${myParam}`,
        schedulingData,
      )
      .then((resp) => {
        const { data } = resp;
        if (data.message != null) {
          setLoading(false);
          if (!pix) {
            setScheduling(true);
            setTimeout(() => {
              navigate("/" + myParam, {
                replace: true,
              });
            }, 5000);
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const fetchPaymentDetails = async (paymentId) => {
    const MAX_DURATION = 5 * 60 * 1000; // 5 minutos em milissegundos
    const INITIAL_DELAY = 60 * 1000; // 1 minuto para a primeira verificação
    const SUBSEQUENT_INTERVAL = 30 * 1000; // 30 segundos para verificações subsequentes
    const startTime = Date.now();

    return new Promise((resolve, reject) => {
      const checkPayment = async (isFirstCheck = false) => {
        try {
          const response = await axios.get(
            `${URL_PreScheduling}/buscaPagamentoMercadoPago`,
            { params: { id: paymentId, alias: myParam } },
          );

          if (
            response.data.success &&
            response.data.responseGenerico.status === "approved"
          ) {
            setScheduling(true); // Chama setScheduling(true) quando o pagamento for aprovado
            setTimeout(() => {
              navigate("/" + myParam, {
                replace: true,
              });
            }, 8000);
            resolve(response.data); // Resolve a promise quando o pagamento for aprovado
            return true; // Para a execução
          }

          // Verifica se o tempo máximo foi excedido
          if (Date.now() - startTime >= MAX_DURATION) {
            console.warn("Tempo máximo de espera excedido (5 minutos)");
            reject(new Error("Tempo máximo de espera excedido"));
            return true; // Para a execução
          }

          // Define o próximo intervalo baseado se é a primeira verificação ou não
          const nextInterval = isFirstCheck
            ? INITIAL_DELAY
            : SUBSEQUENT_INTERVAL;

          // Agenda a próxima verificação
          setTimeout(() => checkPayment(false), nextInterval);
          return false;
        } catch (err) {
          console.error("Erro ao buscar dados do pagamento:", err);

          // Verifica se o tempo máximo foi excedido
          if (Date.now() - startTime >= MAX_DURATION) {
            reject(new Error("Tempo máximo de espera excedido"));
            return true;
          }

          // Define o próximo intervalo baseado se é a primeira verificação ou não
          const nextInterval = isFirstCheck
            ? INITIAL_DELAY
            : SUBSEQUENT_INTERVAL;

          // Em caso de erro, tenta novamente após o intervalo
          setTimeout(() => checkPayment(false), nextInterval);
          return false;
        }
      };

      // Inicia a primeira verificação após 1 minuto
      setTimeout(() => checkPayment(true), INITIAL_DELAY);
    });
  };

  const processPixPayment = async (event) => {
    event.preventDefault();
    setPixLoading(true);
    setError(null);
    setValidationErrors([]);
    const data = {
      transactionAmount: roundAmount(paymentData.amount),
      description: paymentData.description,
      paymentMethodId: "pix",
      deviceId: getDeviceId(),
      payer: {
        email: pixFormData.email,
        firstName: pixFormData.payerFirstName,
        lastName: pixFormData.payerLastName,
        identification: {
          type: "cpf",
          number: pixFormData.identificationNumber,
        },
      },
    };

    try {
      const response = await axios.post(
        `${URL_PreScheduling}/process-pix`,

        data,
        { params: { alias: myParam } },
      );
      if (response.status === 200 || response.status === 201) {
        const result = response.data;
        if (result.status === "pending") {
          setPixPaymentData(result);
          setPixModal(true);
          setSuccess(true);
          try {
            // gera agendamento com financeiro com status de deleted=true, depois do webhook atualizar para false
            SaveSchedulindAndFinancial(true, result.id);
            // Inicia o polling para verificar o status do pagamento se não sair da tela
            await fetchPaymentDetails(result.id);
            console.log("Pagamento PIX aprovado! Gerar agendamento...");
            // TODO: Chamar função para gerar agendamento
          } catch (error) {
            console.error("Erro no polling do pagamento:", error);
          }
        } else {
          setError(`Pagamento PIX não processado: ${result.status_detail}`);
        }
      } else {
        setError("Erro ao processar pagamento PIX");
      }
    } catch (err) {
      console.error("🚨 ERRO COMPLETO NO processPixPayment:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          data: err.config?.data,
        },
        stack: err.stack,
      });

      // Captura específica do erro do backend
      if (err.response?.data?.error) {
        const backendError = err.response.data.error;
        console.log("🔍 ERRO ESPECÍFICO DO BACKEND PIX:", backendError);
        setError(`Erro no pagamento PIX: ${backendError}`);
      } else {
        setError("Erro ao processar pagamento PIX. Tente novamente.");
      }
    } finally {
      setPixLoading(false);
    }
  };

  const handlePixFormChange = (e) => {
    setPixFormData({
      ...pixFormData,
      [e.target.name]: e.target.value,
    });
  };

  const [copyFeedback, setCopyFeedback] = useState("");

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopyFeedback("Código copiado!");
      setTimeout(() => setCopyFeedback(""), 2000);
    });
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setError(null);
      setValidationErrors([]);
      setSuccess(false);
    }
  };

  const togglePixModal = () => {
    setPixLoading(false);
    setPixModal(!pixModal);
  };

  // Helpers de exibição do resumo do agendamento
  const formatCurrency = (value) =>
    Number(value || 0).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

  const bookingServices = schedulingData?.preSchedulingServiceProvideds || [];

  const formattedBookingDate = schedulingData?.date
    ? moment(schedulingData.date).format("DD/MM/YYYY [às] HH:mm")
    : null;

  return (
    <Container>
      <input type="hidden" id="deviceId" />
      <Row className="justify-content-center">
        <Col>
          <Card className="mp-card">
            <CardBody className="mp-card-body">
              <div className="mp-header">
                <h2 className="mp-title">Pagamento</h2>
              </div>

              {error && (
                <Alert color="danger" className="mb-4">
                  {error}
                </Alert>
              )}
              {/* Adicionar após o Alert de erro geral */}
              {validationErrors.length > 0 && (
                <Alert color="warning" className="mb-4">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <strong>Corrija os seguintes erros:</strong>
                      <ListGroup flush className="mt-2">
                        {validationErrors.map((err, index) => (
                          <ListGroupItem
                            key={index}
                            className="border-0 px-0 py-1 small"
                          >
                            <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                            {err.message}
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    </div>
                    <Button
                      color="link"
                      className="p-0 text-warning"
                      onClick={() => setValidationErrors([])}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </div>
                </Alert>
              )}

              {/* Resumo do agendamento — o que está sendo pago */}
              <div className="mp-summary">
                <div className="mp-summary-head">
                  {clinicData?.corporateName && (
                    <span className="mp-summary-clinic">
                      Estabelecimento: {clinicData.corporateName}
                    </span>
                  )}
                  {(providerData?.nameProvider || formattedBookingDate) && (
                    <span className="mp-summary-meta">
                      {providerData?.nameProvider && (
                        <span>
                          Profissional(a): {providerData.nameProvider}
                        </span>
                      )}
                      {formattedBookingDate && (
                        <span>Data: {formattedBookingDate}</span>
                      )}
                    </span>
                  )}
                </div>

                {bookingServices.length > 0 && (
                  <div className="mp-services">
                    {bookingServices.map((service, index) => (
                      <div className="mp-service-row" key={index}>
                        <span className="mp-service-name">
                          {service.description}
                        </span>
                        <span className="mp-service-value">
                          {formatCurrency(service.value)}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="mp-total-row">
                  <span className="mp-total-label">
                    {schedulingData?.partialValue
                      ? "Valor parcial do pagamento:"
                      : "Valor total do pagamento:"}
                  </span>
                  <span className="mp-amount-value">
                    {formatCurrency(paymentData.amount)}
                  </span>
                </div>

                {schedulingData?.partialValue && (
                  <p className="mp-partial-note">
                    <i className="fas fa-info-circle"></i>
                    Você está pagando um sinal/parcial do valor do seu
                    agendamento.
                  </p>
                )}
              </div>

              <Nav tabs className="mb-4">
                {clinicData?.enableCreditCard && (
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggleTab("1")}
                    >
                      <i className="fas fa-credit-card me-2"></i>
                      Cartão de Crédito
                    </NavLink>
                  </NavItem>
                )}
                {clinicData?.enablePix && (
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggleTab("2")}
                    >
                      <i className="fas fa-qrcode me-2"></i>
                      PIX
                    </NavLink>
                  </NavItem>
                )}
              </Nav>

              <TabContent activeTab={activeTab}>
                {/* TAB CARTÃO DE CRÉDITO */}
                <TabPane tabId="1">
                  {!mp ? (
                    <div className="mp-loading">
                      <Spinner color="dark" />
                      <p className="mt-3 mp-muted">
                        Inicializando ambiente seguro...
                      </p>
                    </div>
                  ) : (
                    <Form id="form-checkout" className="mp-form">
                      <div className="mp-section-header">
                        <span className="mp-section-title">
                          Dados do cartão
                        </span>
                        <span className="mp-secure-badge">
                          <i className="fas fa-lock"></i> Pagamento seguro
                        </span>
                      </div>

                      {/* Número do cartão */}
                      <FormGroup className="mp-field">
                        <Label
                          for="form-checkout__cardNumber"
                          className="mp-label"
                        >
                          Número do cartão
                        </Label>
                        <div
                          id="form-checkout__cardNumber"
                          className="mp-input"
                        ></div>
                        <small className="mp-hint">
                          Digite com atenção os números impressos na frente ou
                          atrás do seu cartão.
                        </small>
                      </FormGroup>

                      {/* Validade + Código de segurança */}
                      <Row>
                        <Col xs="6">
                          <FormGroup className="mp-field">
                            <Label
                              for="form-checkout__expirationDate"
                              className="mp-label"
                            >
                              Validade
                            </Label>
                            <div
                              id="form-checkout__expirationDate"
                              className="mp-input"
                            ></div>
                          </FormGroup>
                        </Col>
                        <Col xs="6">
                          <FormGroup className="mp-field">
                            <Label
                              for="form-checkout__securityCode"
                              className="mp-label"
                            >
                              Código de segurança
                            </Label>
                            <div
                              id="form-checkout__securityCode"
                              className="mp-input"
                            ></div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* Nome impresso no cartão */}
                      <FormGroup className="mp-field">
                        <Label
                          for="form-checkout__cardholderName"
                          className="mp-label"
                        >
                          Nome impresso no cartão
                        </Label>
                        <Input
                          type="text"
                          id="form-checkout__cardholderName"
                          placeholder="Como aparece no cartão"
                          className="mp-input-native"
                        />
                      </FormGroup>

                      {/* Banco emissor + Parcelas */}
                      <Row>
                        <Col md="6">
                          <FormGroup className="mp-field">
                            <Label
                              for="form-checkout__issuer"
                              className="mp-label"
                            >
                              Banco emissor
                            </Label>
                            <Input
                              type="select"
                              id="form-checkout__issuer"
                              className="mp-input-native"
                            >
                              <option>Carregando...</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mp-field">
                            <Label
                              for="form-checkout__installments"
                              className="mp-label"
                            >
                              Parcelas
                            </Label>
                            <Input
                              type="select"
                              id="form-checkout__installments"
                              className="mp-input-native"
                            >
                              <option>Carregando...</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="mp-divider"></div>

                      {/* Dados do titular */}
                      <FormGroup className="mp-field">
                        <Label
                          for="form-checkout__identificationNumber"
                          className="mp-label"
                        >
                          CPF do titular
                        </Label>
                        <Input
                          type="text"
                          id="form-checkout__identificationNumber"
                          placeholder="000.000.000-00"
                          className="mp-input-native"
                        />
                      </FormGroup>

                      <FormGroup className="mp-field">
                        <Label
                          for="form-checkout__cardholderEmail"
                          className="mp-label"
                        >
                          E-mail
                        </Label>
                        <Input
                          type="email"
                          id="form-checkout__cardholderEmail"
                          placeholder="seu@email.com"
                          className="mp-input-native"
                        />
                      </FormGroup>

                      <Button
                        type="submit"
                        id="form-checkout__submit"
                        className="mp-pay-btn"
                        disabled={loading}
                        block
                      >
                        {loading ? (
                          <>
                            <Spinner size="sm" className="mr-2" />
                            {" Processando..."}
                          </>
                        ) : (
                          <>
                            <i className="fas fa-lock"></i>
                            {` Pagar ${paymentData.amount.toLocaleString(
                              "pt-br",
                              {
                                style: "currency",
                                currency: "BRL",
                              },
                            )}`}
                          </>
                        )}
                      </Button>

                      <p className="mp-secure-footer">
                        <i className="fas fa-shield-alt"></i>
                        Seus dados são criptografados e processados com
                        segurança pelo Mercado Pago.
                      </p>
                    </Form>
                  )}
                </TabPane>

                {/* TAB PIX */}
                <TabPane tabId="2">
                  <Form onSubmit={processPixPayment} className="mp-form">
                    <div className="mp-section-header">
                      <span className="mp-section-title">Pagar com PIX</span>
                      <span className="mp-secure-badge">
                        <i className="fas fa-bolt"></i> Aprovação imediata
                      </span>
                    </div>

                    <div className="mp-pix-steps">
                      <span>
                        <i className="fas fa-qrcode"></i> Gere o código
                      </span>
                      <i className="fas fa-chevron-right mp-pix-sep"></i>
                      <span>
                        <i className="fas fa-mobile-alt"></i> Pague no app do
                        banco
                      </span>
                      <i className="fas fa-chevron-right mp-pix-sep"></i>
                      <span>
                        <i className="fas fa-check-circle"></i> Confirmação
                        automática
                      </span>
                    </div>

                    <FormGroup className="mp-field">
                      <Label
                        for="form-checkout__payerFirstName"
                        className="mp-label"
                      >
                        Nome completo
                      </Label>
                      <Input
                        type="text"
                        id="form-checkout__payerFirstName"
                        name="payerFirstName"
                        value={pixFormData.payerFirstName}
                        onChange={handlePixFormChange}
                        required
                        placeholder="Seu nome completo"
                        className="mp-input-native"
                      />
                    </FormGroup>

                    <FormGroup className="mp-field">
                      <Label for="form-checkout__email" className="mp-label">
                        E-mail
                      </Label>
                      <Input
                        type="email"
                        id="form-checkout__email"
                        name="email"
                        value={pixFormData.email}
                        onChange={handlePixFormChange}
                        required
                        className="mp-input-native"
                        placeholder="seu@email.com"
                      />
                    </FormGroup>

                    <FormGroup className="mp-field">
                      <Label
                        for="form-checkout__identificationNumber"
                        className="mp-label"
                      >
                        CPF
                      </Label>
                      <Input
                        type="text"
                        id="form-checkout__identificationNumber"
                        name="identificationNumber"
                        value={pixFormData.identificationNumber}
                        onChange={handlePixFormChange}
                        required
                        className="mp-input-native"
                        placeholder="000.000.000-00"
                      />
                    </FormGroup>

                    <Button
                      type="submit"
                      className="mp-pay-btn"
                      disabled={pixLoading}
                      block
                    >
                      {pixLoading ? (
                        <>
                          <Spinner size="sm" className="mr-2" />
                          {" Gerando PIX..."}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-qrcode"></i>
                          {` Gerar PIX de ${formatCurrency(
                            paymentData.amount,
                          )}`}
                        </>
                      )}
                    </Button>

                    <p className="mp-secure-footer">
                      <i className="fas fa-shield-alt"></i>O código PIX expira
                      em 10 minutos. O agendamento é confirmado assim que o
                      pagamento for identificado.
                    </p>
                  </Form>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Modal do PIX */}
      <Modal isOpen={pixModal} toggle={togglePixModal} size="lg">
        <ModalHeader toggle={togglePixModal}>Pagamento via PIX</ModalHeader>
        <ModalBody>
          {pixPaymentData && (
            <div className="text-center">
              <Alert color="info">
                <p className="mb-0">
                  Escaneie o QR Code abaixo ou copie o código PIX
                </p>
                <p className="mb-0">
                  <strong>
                    Ao identificar o pagamento, será gerado automaticamente o
                    agendamento.
                  </strong>
                </p>
                <p className="mb-0 text-danger">
                  Expira em 10 minutos após a geração.
                </p>
              </Alert>

              <div className="mb-4">
                <h6>QR Code</h6>
                {pixPaymentData.point_of_interaction?.transactionData
                  ?.qrCodeBase64 && (
                  <img
                    src={`data:image/jpeg;base64,${pixPaymentData.point_of_interaction.transactionData.qrCodeBase64}`}
                    alt="QR Code PIX"
                    className="img-fluid border rounded"
                    style={{ maxWidth: "300px" }}
                  />
                )}
              </div>

              <FormGroup>
                <Label for="pixCode">
                  <strong>Código PIX (Copiar e Colar)</strong>
                </Label>
                <Input
                  type="text"
                  id="pixCode"
                  value={
                    pixPaymentData.point_of_interaction?.transactionData
                      ?.qrCode || ""
                  }
                  readOnly
                  className="mb-2"
                />
                <Button
                  color="secondary"
                  size="sm"
                  id="copyButton"
                  onClick={() =>
                    copyToClipboard(
                      pixPaymentData.point_of_interaction?.transactionData
                        ?.qrCode,
                    )
                  }
                >
                  <i className="fas fa-copy me-2"></i>
                  Copiar Código
                </Button>
                {/* Tooltip para feedback de cópia */}
                {copyFeedback && (
                  <div className="text-success small mt-1">
                    <i className="fas fa-check me-1"></i>
                    {copyFeedback}
                  </div>
                )}
              </FormGroup>

              <div className="mt-4">
                <Button
                  color="primary"
                  href={
                    pixPaymentData.point_of_interaction?.transactionData
                      ?.ticketUrl
                  }
                  target="_blank"
                >
                  <i className="fas fa-external-link-alt me-2"></i>
                  Abrir no App do Mercado Pago
                </Button>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={togglePixModal}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
      {scheduling && (
        <div>
          {
            <CustomModal
              description={"Agendamento realizado!"}
              icon={<FaCheck />}
              backdrop={"true"}
              background="#F2FFF2"
              isOpen={true}
            />
          }
        </div>
      )}
    </Container>
  );
};

export default MercadoPagoCheckout;
